import React from "react";
import Button from '@mui/material/Button';
import AccountCircle from '@mui/icons-material/AccountCircle';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import useAddVouchereHook from "./addVoucherHook";
import VoucherList from "./voucherList";
import useVouchereListHook from "./voucherListHook";
import PatientAction from "./patientDetails";
import convert from "../../../Helper/helper";

const initialState = {
    voucherDate: convert(new Date()),
    amount: "",
    description: "",
    billingGroupID: "",

}
const AddVoucher = () => {
    const { voucherState, handleChange, handleSubmitVoucher, allowNumbersOnly, handleGoBack,
        BillingGroup, errors, handleBlur, setBillingGroupState} = useAddVouchereHook(initialState);

       
    return (
        <>

            <form className="needs-validation" novalidate>
                <div className="basic-info col-12" >
                    <div className="mt-2 ml-4">
                        <h4>Add Vocuher</h4>
                        <div className="back-btn"
                        onClick={handleGoBack}
                        >
                            <ArrowBackIcon className="arrow-color" />
                            <span
                                style={{ cursor: "pointer" }}
                                className="anchr-link header-text mt-3 mb-3"
                            >
                                {"Back"}
                            </span>
                        </div>
                    </div>
                    <><PatientAction /></>
                    <div className="row mt-3">
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Voucher Date*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><AccountBalanceIcon /></div>
                                    </div>
                                    <input type="date"
                                        onBlur={handleBlur}
                                        className={
                                            errors?.voucherDate ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Voucher Date" name="voucherDate"
                                        value={voucherState?.voucherDate}
                                        onChange={handleChange}
                                        required />
                                    <div class="invalid-feedback">
                                        {errors && errors?.voucherDate}.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Amount*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        type="text"
                                        className={
                                            errors?.amount ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        placeholder="Amount" name='amount'
                                        value={voucherState?.amount}
                                        onChange={handleChange}
                                        onKeyDown={(e) => allowNumbersOnly(e)}
                                    />
                                    <div class="invalid-feedback">
                                        {errors && errors?.amount}.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Billing Group*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><AccountCircle /></div>
                                    </div>
                                    <select
                                        onBlur={handleBlur}
                                        className={
                                            errors?.billingGroupID ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        selected={voucherState?.billingGroupID}
                                        value={voucherState?.billingGroupID}
                                        onChange={handleChange}
                                        required
                                        name="billingGroupID"
                                    >
                                        <option></option>
                                        {
                                            BillingGroup && BillingGroup?.length > 0 && BillingGroup?.map((ele) => (
                                                <option value={ele?.uniqueID}>{ele?.billingGroupName}</option>
                                            ))
                                        }


                                    </select>
                                    <div class="invalid-feedback">
                                        {errors && errors?.billingGroupID}.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Description*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fa fa-address-card" aria-hidden="true"></i></div>
                                    </div>
                                    <textarea
                                        type="text"
                                        className="form-control" id="lname"
                                        placeholder="Description" name="description"
                                        value={voucherState?.description}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end mr-3 mb-3">
                        <Button variant="outlined" className="mr-2" onClick={(event) => {
                            handleSubmitVoucher(event, voucherState)
                            setBillingGroupState(initialState)
                        }}>Add Voucher</Button>
                    </div>
                </div>
            </form>
            <section>
                <VoucherList />
            </section>
            
        </>
    );
};

export default AddVoucher;